module.exports = __webpack_public_path__ + "static/media/logo-full.7252d0f6.png";